import { useContext } from "react";
import { ExpenseContext } from "contexts";

export default () => useContext(ExpenseContext);
